import React from 'react'

import { BrandedAlertModal } from 'components/Modal'
import type { BrandedAction } from 'components/Modal/BrandedAlertModal/BrandedAlertModal'

interface ShowContactsConfirmationProps {
    isOpen: boolean
    onConfirm: () => void
    name: string
}

// T2-6644: constrained branded modal (same shell as Request Resume / Score Info).
const ShowContactsConfirmation = ({
    isOpen,
    onConfirm,
    name,
}: ShowContactsConfirmationProps) => {
    const actions: BrandedAction[] = [
        {
            label: 'OK',
            variant: 'primary',
            onClick: onConfirm,
            ariaLabel: 'confirm-button',
        },
    ]

    return (
        <BrandedAlertModal
            isOpen={isOpen}
            onClose={onConfirm}
            title="Contact Details shared"
            ariaLabel="Contact Details shared"
            actions={actions}
        >
            <p>{name} can now see your contact details.</p>
        </BrandedAlertModal>
    )
}

export default ShowContactsConfirmation;
